<template>
    <div class="company-no-permission mt-5 flex justify-center">
        <div class="company-no-permission-content h-[464px]">
            <div class="flex h-full flex-col items-center justify-center px-4">
                <PtIcon icon="NoPermissionIcon" class="h-[100px] w-[130px] text-[145px]"></PtIcon>
                <div class="text-xs text-gray-450">{{ textInfo}}</div>
                <button class="th-btn " @click="handleUpgradeNow" v-if="isFreemium">{{ t('upGradeNow') }}</button>
            </div>
        </div>

    </div>
</template>

<script setup lang="ts">
import { PtIcon } from 'patsnap-biz';
import { i18n } from '@/infrastructure/locales';
import { EActivityTriggerType } from '@eureka/services/src/types/activity-type';
import { useI18n } from 'vue-i18n';
import { useGlobalState } from '@/composables/use-global-store';
import { computed } from 'vue';
import '@/assets/icon/no-permission-icon.svg';

const { isFreemium } = useGlobalState()
const { t } = useI18n()
const textInfo = computed(() => {
    return isFreemium.value ? t('noPermissionTip') : t('noPermissionTipForTrial')
})
function handleUpgradeNow() {
    /**
         * 弹出邀请活动
         */
    import('@eureka/upgrade-activity').then((mod) => {
        mod.openUpgradeActivity(i18n, { activityTriggerType: EActivityTriggerType.read_more_company })
    })
}
</script>
<style lang="scss">
.company-no-permission {
    &-content {
        width: 100%;
        height: 100%;
        background: url('@/assets/img/no-permission.png') no-repeat center;
        background-color: #fff;
        padding: 0 20px;
        .th-btn {
            margin-top: 20px;
        }
    }
}
</style>
